// Copyright ©️ 2026 eVolve MEP, LLC

export const CROSS_MARK_PATH_TOKENS: (string | number)[] = [
  'M',
  6.4,
  19,
  'L',
  5,
  17.6,
  'L',
  10.6,
  12,
  'L',
  5,
  6.4,
  'L',
  6.4,
  5,
  'L',
  12,
  10.6,
  'L',
  17.6,
  5,
  'L',
  19,
  6.4,
  'L',
  13.4,
  12,
  'L',
  19,
  17.6,
  'L',
  17.6,
  19,
  'L',
  12,
  13.4,
  'Z',
];
